import { AlertColorTokens } from '../types'

/**
 * The dedicated alert palette — shared by every theme pack.
 *
 * Mapped onto Egowall spectrum stops (gold → coral → violet → cyan) so
 * toasts/banners feel on-brand instead of generic green/red/blue.
 * Meanings stay fixed across Spectrum / Default / Vivid packs.
 *
 *   success → cyan  #01DAFE
 *   error   → coral #FEA67D
 *   warning → gold  #FFCF7D
 *   info    → violet #BE9DFD
 */
export const ALERT_COLORS: AlertColorTokens = {
  ok: '#01DAFE',
  okSoft: 'rgba(1, 218, 254, 0.12)',
  okLine: 'rgba(1, 218, 254, 0.38)',
  okInk: '#0A6B7A',
  err: '#FEA67D',
  errSoft: 'rgba(254, 166, 125, 0.14)',
  errLine: 'rgba(254, 166, 125, 0.45)',
  errInk: '#9A4A32',
  warn: '#FFCF7D',
  warnSoft: 'rgba(255, 207, 125, 0.16)',
  warnLine: 'rgba(255, 207, 125, 0.55)',
  warnInk: '#8A5A00',
  info: '#BE9DFD',
  infoSoft: 'rgba(190, 157, 253, 0.14)',
  infoLine: 'rgba(190, 157, 253, 0.42)',
  infoInk: '#5A3A8F',
}
